import React from 'react'
import { AiOutlinePlus } from 'react-icons/ai';
import { CiSearch } from 'react-icons/ci';

type AdsSearchMenuProps ={
  setFilterText: React.Dispatch<React.SetStateAction<string>>;
  filterText: string;
  openOption: boolean;
  setOpenOption: React.Dispatch<React.SetStateAction<boolean>>;
}
const AdsSearchMenu: React.FC<AdsSearchMenuProps> = ({setFilterText, openOption, setOpenOption, filterText}) => {


  return (
    <div className='flex justify-between mb-10 font-medium'>
      <div className="w-[32%] relative">
        <input 
          type="text" 
          className='w-full border border-[#CCC] border-solid outline-none rounded-lg placeholder:text-searchCol placeholder:font-medium placeholder:font-Poppins h-11 py-3 pl-9 text-sm text-searchCol bg-comPagBg'
          placeholder='Search'
          value={filterText}
          onChange={(e) => {
            setFilterText(e.target.value)
          }}
        />
        <div className="absolute left-3 top-[13px]">
          <CiSearch className=" text-searchCol"/>
        </div>
      </div>

      <div className="flex w-[40%] text-sm justify-between">
        <div className="border w-[67%] border-[#CCC] border-solid text-[#555] flex justify-center rounded-lg items-center ">
          Review and Publish
        </div>
      
        <div 
          className="bg-midGreen text-white flex justify-center rounded-lg items-center gap-1 w-24 cursor-pointer active:w-[90px] active:h-10 active:mb-1 active:mx-[3px]" 
          onClick={() => setOpenOption(!openOption)}
        >
          New
          <AiOutlinePlus className='fill-white'/>
        </div>
      </div>     
    </div>
  )
}

export default AdsSearchMenu;